import request from '@/utils/request'
const apiPath = '/sys/complianceStandardsConfig'
const complianceStandardsConfigApi = {
  /**
   * 新增【达标标准】
   */
  create(data) {
    return request.post(apiPath + '/addConfig', data, { isFormData: 1 })
  },
  /**
   * 修改【达标标准】
   */
  update(data) {
    return request.put(apiPath, data)
  },
  /**
   * 分页查询【达标标准】
   */
  fetchList(query) {
    return request.get(apiPath, { params: query })
  },
  /**
   * 查看【达标标准】详情
   */
  fetchById(id) {
    return request.get(`${apiPath}/${id}`)
  },
  /**
   * 删除单个【达标标准】
   */
  deleteById(id) {
    return request.delete(`${apiPath}/${id}`)
  },
  /**
   * 批量删除【快递配置】
   */
  deleteBatch(ids) {
    return request.delete(apiPath, { data: ids })
  },
}
export default complianceStandardsConfigApi
